export default "__VITE_ASSET__yusuI6Rf__"